import { useParams } from 'react-router-dom';
import { useUnmount } from 'ahooks';
import { Col, Row } from 'antd';

import { Container, TitledContainer } from 'components';

import { getIsNew } from 'utils';

import {
  ProductActions,
  ProductForm,
  ProductImage,
  ProductTabs,
  Title,
  TitleExtraNode,
} from './components';
import { resetProductAction } from './store';

export const Product = () => {
  const { productId } = useParams();

  const isNew = getIsNew(productId);

  useUnmount(() => {
    resetProductAction();
  });

  return (
    <TitledContainer
      backLink
      scrollable
      title={<Title />}
      titleExtraNode={<TitleExtraNode />}
      underTitleNode={<ProductActions />}
    >
      <Container className='mb-7'>
        <Row gutter={24}>
          <Col xs={8} xxl={6}>
            <ProductImage />
          </Col>

          <Col xl={12}>
            <ProductForm />
          </Col>
        </Row>
      </Container>

      {!isNew && (
        <Container>
          <ProductTabs />
        </Container>
      )}
    </TitledContainer>
  );
};
